export default __webpack_public_path__ + "static/media/not-found.72c08323.svg";